import useJourneyPlan from "./useJourneyPlan";
const useJourneyLeg = (legId) => {
  const { legs } = useJourneyPlan();
  const journeyLeg = legs.find((leg) => leg.id === legId);
  if (!journeyLeg) {
    throw new Error(`Leg ${legId} is not a valid leg for the current journey.`);
  }
  return journeyLeg;
};
var useJourneyLeg_default = useJourneyLeg;
export {
  useJourneyLeg_default as default
};
